import { createAction, props } from '@ngrx/store';

import type { UserConsentItem } from '../../services/consent.rest.service';
import { prefixed } from '../../../../shared/utils/factory.utils';

const consent = prefixed('[Consent]');

export const ConsentActions = {
  openConsentModal: createAction(consent('Open Consent Modal'), props<{ language: string }>()),
  closeConsentModal: createAction(consent('Close Consent Modal')),

  appResumedSucceeded: createAction(consent('App Resumed succeeded'), props<{ consents: Array<UserConsentItem> }>()),
  appResumedFailed: createAction(consent('App Resumed failed'), props<{ error: unknown }>()),

  missingConsentsRequested: createAction(consent('Missing Consents Requested'), props<{ language: string }>()),
  missingConsentsRequestedSucceeded: createAction(consent('Missing Consents Requested succeeded'), props<{ consents: Array<UserConsentItem> }>()),
  missingConsentsRequestedFailed: createAction(consent('Missing Consents Requested failed'), props<{ error: unknown }>()),

  toggleConsentItem: createAction(consent('Toggle Consent Item'), props<{ id: string }>()),
  viewConsentDocument: createAction(consent('View Consent Document'), props<{ id: string; documentUrl: string }>()),

  submitConsentUpdate: createAction(
    consent('Submit Consent Update'),
    props<{ consents: Array<UserConsentItem>; mode: 'onboarding' | 'update'; language: string }>()
  ),
  submitConsentUpdateSucceeded: createAction(consent('Submit Consent Update succeeded'), props<{ mandatoryRevoked: boolean }>()),
  submitConsentUpdateFailed: createAction(consent('Submit Consent Update failed'), props<{ error: unknown }>()),
};
